import Tooltip from '@mui/material/Tooltip'

export const renderElementsTableLC = (row, currentCurriculum, id) => {
  const renderTooltip = (id, string) => {
    return string.length > 30 ? <Tooltip arrow id={`tooltip-${id}`} placement='top' title={string}><span className='text-sm cursor-pointer'>{string.substring(0, 30) + '...'}</span></Tooltip> : <span className='text-sm'>{string}</span>
  }

  const elements = {}
  Object.keys(row.lcElements || {}).forEach((element) => {
    if (row.lcElements[element]) {
      elements[element] = renderTooltip(`${id}-lc-elements-${row._id}-${element}`, row.lcElements[element])
    }
  })
  Object.keys(row.curriculumElements || {}).forEach((element) => {
    const mapElements = (key, value, children, tooltip = true) => {
      const find = children?.find((child) => child._id === value.value)
      if (find) {
        elements[key] =  tooltip ? renderTooltip(`${id}-lc-element-${row._id}-${key}`, find.name) : find.name
        Object.keys(value?.children || {}).forEach((child) => {
          const el = find.elements?.find((c) => c.elementStructureId === child)
          if (el) {
            mapElements(child, value.children[child], el.children)
          }
        })
      }
    }
    mapElements(element, row.curriculumElements[element], currentCurriculum.elements?.children || [], false)
  })

  return elements
}
